import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@flatfy/supernova-new';
import { FlatsFiltersEmptyStatesContext } from '../../FlatsFilters/FlatsFiltersContext';
import Image from '../../react-components/Image/Image';

const DEFAULT_EMPTY_STATE = {
  image: '/images/empty-state/layouts.png',
  image2x: '/images/empty-state/layouts@2x.png',
  title: 'emptyState.notFound.title',
  subtitle: 'emptyState.notFound.subtitle',
};

export const EMPTY_STATES = {
  ALL_SOLD: 'all_sold',
  NOT_STARTED: 'not_started',
  EMPTY: 'empty',
  NOT_FOUND: 'not_found',
};

const EMPTY_STATES_CONFIG = {
  [EMPTY_STATES.ALL_SOLD]: {
    image: '/images/empty-state/flats-allSold.png',
    image2x: '/images/empty-state/flats-allSold@2x.png',
    title: 'emptyState.allSold.title',
    subtitle: 'emptyState.allSold.subtitle',
  },
  [EMPTY_STATES.NOT_STARTED]: {
    image: '/images/empty-state/flats-notStarted.png',
    image2x: '/images/empty-state/flats-notStarted@2x.png',
    title: 'emptyState.notStarted.title',
    subtitle: 'emptyState.notStarted.subtitle',
  },
  [EMPTY_STATES.EMPTY]: {
    image: '/images/empty-state/layouts.png',
    image2x: '/images/empty-state/layouts@2x.png',
    title: 'emptyState.empty.title',
    subtitle: 'emptyState.empty.subtitle',
  },
  [EMPTY_STATES.NOT_FOUND]: DEFAULT_EMPTY_STATE,
};

const FlatsEmptyStates = () => {
  const { emptyState } = useContext(FlatsFiltersEmptyStatesContext);
  const emptyStateConfig = EMPTY_STATES_CONFIG[emptyState] ?? DEFAULT_EMPTY_STATE;

  return (
    <div className="FlatsEmptyStates">
      <Image
        useWebp
        src={emptyStateConfig.image}
        src2x={emptyStateConfig.image2x}
        className="FlatsEmptyStates-image"
      />
      <div className="FlatsEmptyStates-title">
        <FormattedMessage id={emptyStateConfig.title} />
      </div>
      <Typography variant="caption">
        <FormattedMessage id={emptyStateConfig.subtitle} />
      </Typography>
    </div>
  );
};

export default FlatsEmptyStates;
